import moment from 'moment';

import Quote from '../Quote/Quote';
import RelatedCaseStudy from '../CaseStudy/RelatedCaseStudy';

const getCategoeies = (offerings) => {
  return offerings?.map(offering => offering?.title) || [];
}

class CaseStudy {
  constructor(contentfulNode) {
    this.id = contentfulNode?.id;
    this.createdAt = contentfulNode?.createdAt;
    this.updatedAt = contentfulNode?.updatedAt;
    this.title = contentfulNode?.title ?? 'Case Study Title';
    this.metaTitle = contentfulNode?.metaTitle;
    this.metaDescription = contentfulNode?.metaDescription?.internal?.content ?? '';
    this.slug = contentfulNode?.slug;
    this.localizationSlug = contentfulNode?.localizationSlug;
    this.clientName = contentfulNode?.clientName;
    this.snippet = contentfulNode?.snippet?.snippet ?? contentfulNode?.snippet ?? 'Case Study Snippet';
    this.categories = contentfulNode?.categories || getCategoeies(contentfulNode?.offerings) || [];
    this.heroImageData = {
      fluid: contentfulNode?.heroImage?.gatsbyImageData,
      title: contentfulNode?.title
    };
    this.featuredContentTitle = contentfulNode?.featuredContentTitle;
    this.featuredContentHeroImage = {
      title: contentfulNode?.featuredContentTitle,
      fluid: contentfulNode?.featuredContentHeroImage?.gatsbyImageData
    };
    this.atAGlanceRichJSON = contentfulNode?.atAGlance;
    this.relatedIndustries = contentfulNode?.industry;
    this.videoBlockAtTop = contentfulNode?.videoBlockAtTop;
    this.relatedServiceLines = contentfulNode?.offerings;
    this.theChallengeTitle = contentfulNode?.theChallengeTitle;
    this.theChallengeContentRichJSON = contentfulNode?.theChallengeContent;
    this.theChallengeMediaData = {
      fluid: contentfulNode?.theChallengeMedia?.gatsbyImageData,
      title: contentfulNode?.theChallengeMedia?.title
    };
    this.theSolutionTitle = contentfulNode?.theSolutionTitle;
    this.theSolutionContentRichJSON = contentfulNode?.theSolutionContent;
    this.theSolutionMediaData = {
      fluid: contentfulNode?.theSolutionMedia?.gatsbyImageData,
      title: contentfulNode?.theSolutionMedia?.title
    };
    this.theResultsTitle = contentfulNode?.theResultsTitle;
    this.theResultsContentRichJSON = contentfulNode?.theResultsContent;
    this.theResultsMediaData = {
      fluid: contentfulNode?.theResultsMedia?.gatsbyImageData,
      title: contentfulNode?.theResultsMedia?.title
    };
    this.quoteBlock = contentfulNode?.quoteBlock ? new Quote(contentfulNode?.quoteBlock) : null;
    this.video = contentfulNode?.video;
    this.metricsBlock = contentfulNode?.metricsBlock;
    this.relatedCaseStudies = contentfulNode?.relatedCaseStudies
      ? contentfulNode?.relatedCaseStudies.map(caseStudy => new RelatedCaseStudy(caseStudy))
      : [];
    this.tools = contentfulNode?.tools;
  }

  /**
   * Getter which receives a moment-compliant format string and returns
   * the Insights updatedAt applying the given format
   *
   * @function getFormattedModificationDate
   * @param {string} formatString Moment-compliant format string -> https://momentjs.com/docs/#/displaying/format/
   * @returns {string} Formatted date string
   */
  getFormattedModificationDate = formatString => {
    return moment(this.updatedAt).format(formatString);
  };

  /**
   * Getter which receives a moment-compliant format string and returns
   * the Insights createdAt by applying the given format
   *
   * @function getFormattedCreationDate
   * @param {string} formatString Moment-compliant format string -> https://momentjs.com/docs/#/displaying/format/
   * @returns {string} Formatted date string
   */
  getFormattedCreationDate = formatString => {
    return moment(this.createdAt).format(formatString);
  };
}

export default CaseStudy;
